import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "I've left feeling more like myself, not less. Shawnna treats your face like art — patient, considered, never rushed.",
    name: "Eloise M.",
    location: "Brisbane",
  },
  {
    quote:
      "Finally a clinic that says no when something isn't right for you. My skin has never been calmer or clearer in my forties.",
    name: "Priya R.",
    location: "Daisy Hill",
  },
  {
    quote:
      "Professional, warm and the results speak for themselves. I drive an hour to come here and won't go anywhere else.",
    name: "Hannah W.",
    location: "Gold Coast",
  },
];

export default function Testimonials() {
  const [idx, setIdx] = useState(0);

  const go = (dir) => {
    setIdx((p) => (p + dir + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  const t = TESTIMONIALS[idx];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-16 bg-[#FDFBF7]"
    >
      <div className="max-w-5xl mx-auto text-center">
        <p className="eyebrow mb-8">Words from clients</p>
        <Quote size={36} strokeWidth={1} className="mx-auto text-[#C89F95] mb-8" />

        <div className="relative min-h-[260px] md:min-h-[220px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={idx}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.5 }}
              className="max-w-3xl"
              data-testid="testimonial-quote"
            >
              <p className="font-serif italic text-2xl md:text-3xl leading-snug text-[#2D2926] mb-8">
                &ldquo;{t.quote}&rdquo;
              </p>
              <footer className="eyebrow text-[#5C5753]">
                {t.name} · <span className="text-[#C89F95]">{t.location}</span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-4 mt-12">
          <button
            data-testid="testimonial-prev"
            onClick={() => go(-1)}
            className="w-11 h-11 rounded-full border border-[#E8DFD8] flex items-center justify-center hover:bg-[#C89F95] hover:text-white hover:border-[#C89F95] transition-colors"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={18} strokeWidth={1.5} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                data-testid={`testimonial-dot-${i}`}
                onClick={() => setIdx(i)}
                className={`h-1 transition-all ${
                  i === idx ? "w-8 bg-[#C89F95]" : "w-4 bg-[#E8DFD8]"
                }`}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
          <button
            data-testid="testimonial-next"
            onClick={() => go(1)}
            className="w-11 h-11 rounded-full border border-[#E8DFD8] flex items-center justify-center hover:bg-[#C89F95] hover:text-white hover:border-[#C89F95] transition-colors"
            aria-label="Next testimonial"
          >
            <ChevronRight size={18} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </section>
  );
}
